import React from 'react';
import { Form, Modal } from 'react-bootstrap';
import TextArea from 'components/DesignSystem/TextArea';
import TextField from 'components/DesignSystem/TextField';
import Button from 'components/DesignSystem/Button';
import useWarningFormModal from 'hooks/NewHome/Table/Warnings/useWarningFormModal';

export default function WarningFormModal({
  header,
  title,
  setTitle,
  message,
  setMessage,
  expirationTime,
  setExpirationTime,
  show,
  dismiss,
  saveWarning,
  formValidated,
}: {
  header: string,
  title: string,
  setTitle: (v: string) => void,
  message: string,
  setMessage: (v: string) => void,
  expirationTime: number,
  setExpirationTime: (v: number) => void,
  show: boolean,
  dismiss: () => void,
  saveWarning: () => void,
  formValidated: boolean,
}) {
  const {
    updateExpirationTime,
    isExpirationTimeValid,
  } = useWarningFormModal();

  return (
    <Modal show={show} onHide={dismiss}>
      <Modal.Header className="ms-3 me-3" closeButton>
        <h3 className="preview-title"><strong>{header}</strong></h3>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <TextField
            label="Título"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            error={formValidated && !title ? 'Título não pode ficar em branco' : undefined}
          />
        </Form.Group>
        <TextArea
          label="Mensagem"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          rows={10}
          className="mt-2"
          error={formValidated && !message ? 'Mensagem não pode ficar em branco' : undefined}
        />
        <Form.Group>
          <TextField
            controlId="expirationTime"
            label="Tempo de expiração, em horas"
            value={expirationTime}
            onChange={(e) => updateExpirationTime(e.target.value, setExpirationTime)}
            className="mt-2"
            error={
              isExpirationTimeValid
                ? undefined
                : 'É necessário definir um tempo de expiração mínimo de 1 hora'
            }
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={saveWarning}>Salvar</Button>
      </Modal.Footer>
    </Modal>
  );
}
